import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/starIcon.svg'


const _hoisted_1 = { class: "product-details" }
const _hoisted_2 = {
  key: 0,
  class: "product-details-box"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "product-details-box-info" }
const _hoisted_5 = { class: "title-text" }
const _hoisted_6 = { class: "body-text" }
const _hoisted_7 = { class: "product-details-box-info-quantity" }
const _hoisted_8 = { class: "body-text-bold" }

import QuantityComponent from '@/components/form-components/QuantityComponent.vue';
import NotFoundComponent from '@/components/NotFoundComponent.vue';
import { generalStore } from '@/store';
import { Product } from '@/types';
import axios from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import __ from '@/translate';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductDetails',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const product = ref<Product | null>(null);
const store = generalStore();
const quantity = ref(1);
const notFound = ref(false);

onMounted(() => {
  fetchProductDetails();
});

function fetchProductDetails() {
  axios
    .get(`/api/products/${route.params.id}`)
    .then((response) => {
      product.value = response.data;
    })
    .catch(() => {
      notFound.value = true;
    });
}

function buyItem() {
  if (product.value) {
    router.push({
      name: 'CheckoutPage',
      params: {
        id: product.value.id,
        quantity: quantity.value,
      },
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (product.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: product.value.imageUrl,
            class: "product-details-box-image"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(product.value.name), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(product.value.description), 1),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "border-space-breaker" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(QuantityComponent, {
                placeHolder: _unref(__)('item_quantity'),
                modelValue: quantity.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((quantity).value = $event))
              }, null, 8, ["placeHolder", "modelValue"]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(store).formatPrice(product.value.price)), 1)
            ]),
            _createElementVNode("button", {
              class: "button",
              onClick: buyItem
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_unref(__)('product_buy')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (notFound.value)
      ? (_openBlock(), _createBlock(NotFoundComponent, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})